
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {accountResource} from "@/modules/Profile/resources/accounts.resource";
import SimpleAppTable from "@/shared/AppTable/components/SimpleAppTable.vue";
import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";
import {IApp} from "@/interfaces/app.interface";
import {IAccounts} from "@/modules/Profile/interfaces/accounts.interface";
import ActiveCell from "@/modules/Profile/components/accounts/ActiveCell.vue";
import AppSwitch from "@/components/AppSwitch.vue";
import {bus} from "@/plugins/bus";
import {ICorp} from "@/modules/Corps/interfaces/corp.interface";
import {isMobile} from "mobile-device-detect";

  @Component({
    components: {
      AppSwitch,
      SimpleAppTable,
      ActiveCell,
    }
  })
  export default class AccountsTable extends Vue {
    @Prop() corpId: number;
    @Prop() corpName: string;
    @Prop() fromCorp: boolean;

    $refs: any;
    tableList: IAccounts.IPerson[] = [];
    loading = true;
    ActiveCell = ActiveCell;
    filterEnabled = true;

    tableName = 'accounts';
    sortingTable = {
      prop: null,
      propType: IApp.SortingPropType.String,
      direction: IApp.SortDirection.Default,
    };

    get dataProps(): IAppTable.ITableProp[] {
      return [
        {
          label: 'Аккаунт',
          prop: 'name',
          propType: IApp.SortingPropType.String,
          mobileHide: true,
          actionClick: (row) => this.openEditPopup(row, true),
        },
        { label: 'ФИО',
          prop: 'fio',
          propType: IApp.SortingPropType.String,
          actionClick: (row) => this.openEditPopup(row, true),
        },
        { label: 'Телефон',       prop: 'phone',      propType: IApp.SortingPropType.String, mobileHide: true, },
        { label: 'E-mail',        prop: 'email',      propType: IApp.SortingPropType.String, mobileHide: true, },
        {
          label: 'Активность',
          prop: 'enabled',
          propType: IApp.SortingPropType.CustomComponent,
          customComponentName: 'ActiveCell',
          noSorting: true,
        },
        {
          label: 'Действия',
          prop: 'actions',
          propType: IApp.SortingPropType.Actions,
          actions: [
            { tooltip: 'Редактировать', icon: 'edit', actionClick: this.openEditPopup, disabled: false },
          ],
        },
      ];
    }
    get sortedList() {
      return IAppTable.SortTableData({
        tableData: this.tableList,
        sortingTable: this.sortingTable,
      }).array;
    }

    async created() {
      await this.getTableData();
    }

    async mounted() {
      bus.$on(IAccounts.Events.AccountTableCreateItem, (person) => {
        this.sortedList.unshift(person);
        this.$refs.SimpleAppTable.$forceUpdate();
      });
      bus.$on(IAccounts.Events.AccountTableUpdateItem, (person) => {
        let personIndex = this.sortedList.findIndex(item => item.id === person.id);
        if (personIndex !== -1) {
          this.sortedList[personIndex] = person;
          this.$refs.SimpleAppTable.$forceUpdate();
        }
      });

      let presetSorting = IAppTable.PresetStorageSorting(this.tableName);
      if (presetSorting && !!presetSorting.prop) {
        Vue.set(this, 'sortingTable', presetSorting);
      }
      else {
        let cell = this.dataProps.find(item => item.prop === 'fio');
        this.setSorting(cell);
      }
    }

    async getTableData() {
      if (!this.corpId) return;

      this.loading = true;
      let payload = {
        corpId: this.corpId,
        fltEnabled: this.filterEnabled
      };
      this.tableList = await accountResource.getAccountsByCorp(payload);
      this.loading = false;
    }

    async openEditPopup(person: IAccounts.IPerson, cellClick = false) {
      if (cellClick && isMobile) return;

      await this.openAccountPopup(false, person);
    }

    async changeStatus(data: { entity: IAccounts.IPerson; index: number; value: boolean; }) {
      let requestData = await accountResource.updateAccount({ id: data.entity.id, enabled: data.value });
      this.$notify({
        title: requestData.success ? 'Успешно' : 'Ошибка',
        message: requestData.success ? 'Статус аккаунта изменен' : 'Статус аккаунта не был изменен',
        type: requestData.success ? 'success' : 'error',
      });
      if (requestData.success) {
        Vue.set(this.sortedList[data.index], 'enabled', data.value);
      }
    }

    async openAccountPopup(createMode = false, person?: IAccounts.IPerson) {
      await this.$store.dispatch('dialog/openDialog', {
        blockName: 'profile',
        dialogName: 'accountPopup',
        payload: {
          createMode,
          corpId: this.corpId,
          corpName: this.corpName,
          person,
        },
      });
    }

    async openEventsLog() {
      await this.$store.dispatch('dialog/openDialog', {
        blockName: 'profile',
        dialogName: 'accountLogPopup',
        payload: {
          corpId: this.corpId,
        }
      });
    }

    setSorting(cell: IAppTable.ITableProp) {
      let sortingData = IAppTable.SetSorting(this.sortingTable, cell, this.tableName);
      Vue.set(this, 'sortingTable', sortingData);
    }

    destroyed() {
      bus.$off(IAccounts.Events.AccountTableCreateItem);
      bus.$off(IAccounts.Events.AccountTableUpdateItem);
    }

    @Watch('corpId')
    async onCorpIdChange() {
      await this.getTableData();
    }

  }
